import { Model } from "@danangelus/ngx-app-core"

/**
 * Model class for a registered SAML Provider
 *
 * @author Hayden Eastwell
 */
export class SamlServiceProvider extends Model {

    id: number | undefined
    created: Date | undefined
    lastModified: Date | undefined
    entityId: string | undefined
    acsUrl: string | undefined
    acsValidatorPattern: string | undefined
    signatureAlgorithm: string | undefined
    signatureKey: string | undefined
    signaturePassword: string | undefined
    encryptionCertificate: string | undefined
    enabled: boolean | undefined

    constructor(serviceProvider: any) {
        super(serviceProvider)
    }
}
